import { render, staticRenderFns } from "./Continue.vue?vue&type=template&id=b6889d80&scoped=true&"
import script from "./Continue.vue?vue&type=script&lang=js&"
export * from "./Continue.vue?vue&type=script&lang=js&"
import style0 from "./Continue.vue?vue&type=style&index=0&id=b6889d80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6889d80",
  null
  
)

export default component.exports